export default __webpack_public_path__ + "static/media/Human.fc22379d.webm";